module.exports = "<div class=\"flexroot\">\r\n    <div class=\"flexheader\">\r\n        <div class=\"headerfontbold\">LET OP</div>\r\n    </div>\r\n    <div class=\"flexsubheader\">\r\n        <div class=\"panel-buttons\">\r\n            <fw-bar-button [title]=\"'SLUITEN'\" [clickEventType]=\"'close'\" (buttonClick)=\"btnClicked($event)\"></fw-bar-button>\r\n        </div>\r\n    </div>\r\n    <div class=\"flexcontent\">\r\n        {{ message }}\r\n    </div>\r\n    <div class=\"flexfooter\"></div>\r\n</div>";


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/shared/message.component.html
// module id = 2108
// module chunks = 1